import { Linkedin, ArrowUpRight } from "lucide-react";
import { TEAM } from "../data/site";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { CtaBlock } from "./About";

export default function Team() {
  return (
    <>
      <PageHero
        eyebrow="Leadership"
        title={<>Engineers, not<br/><span className="text-[var(--primary)]">salespeople.</span></>}
        subtitle="UMD is run by senior engineers with deep domain expertise. Every leader on this page can — and does — sit at a workbench."
        image="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1920&q=80"
      />

      <section className="py-24 md:py-32 container-wide">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={i * 60}>
              <div className="group" data-testid={`team-card-${i}`}>
                <div className="aspect-[3/4] overflow-hidden bg-[#e5e5e5] relative">
                  <img src={m.image} alt={m.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105" />
                  <a href="#" className="absolute bottom-4 right-4 w-10 h-10 bg-white text-[#0a0a0a] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[var(--primary)] hover:text-white">
                    <Linkedin size={16}/>
                  </a>
                </div>
                <div className="mt-6 flex items-start justify-between">
                  <div>
                    <h3 className="font-display text-2xl tracking-tight">{m.name}</h3>
                    <div className="font-mono-tech text-[11px] tracking-[0.15em] uppercase text-[var(--muted-fg)] mt-1">{m.role}</div>
                  </div>
                  <ArrowUpRight size={18} className="text-[var(--muted-fg)] group-hover:text-[var(--primary)] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBlock />
    </>
  );
}
